export enum EActionEvents {
  openSite = 'Site Opened',
  loginViaPasswordStarted = 'Login Via Password Started',
  loginViaPasswordCompleted = 'Login Via Password Completed',
  loginViaOTPStarted = 'Login Via OTP Started',
  loginViaOTPCompleted = 'Login Via OTP Completed',
  signUpStarted = 'Signup Started',
  signUpCompleted = 'Signup Completed',
  changeInPage = 'Change in Page',
}
